/**
 * Due to the way webpack 5 replaces "process.env" with an object
 * it is better to use a variable for all access to env variables
 */
export const buildEnvironment = process.env;

export const getBaseUrl = () => {
  const location = window.location;
  return `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ``}`;
}

export const getEnv = (key: string): string | undefined =>
  buildEnvironment[key] ?? undefined;

/**
 * Build env variables from codebuild
 * @link https://docs.aws.amazon.com/codebuild/latest/userguide/build-env-ref-env-vars.html
 */
export const codebuildEnv = {
  // if was build from codebuild
  isCodebuild: (getEnv(`REACT_APP_CODEBUILD_BUILD_NUMBER`) !== undefined),
  // The current build number for the project
  buildNumber: getEnv(`REACT_APP_CODEBUILD_BUILD_NUMBER`),
  // This variable contains the commit ID
  resolvedSourceVersion: getEnv(`REACT_APP_CODEBUILD_RESOLVED_SOURCE_VERSION`),
  // the commit ID, branch name, or tag name associated with the version of the source code to be built
  sourceVersion: getEnv(`REACT_APP_CODEBUILD_SOURCE_VERSION`),
  // The start time of the build specified as a Unix timestamp in milliseconds
  startTime: getEnv(`REACT_APP_CODEBUILD_START_TIME`),
  // The base reference name of the webhook event that triggers the current build.
  // For a pull request, this is the branch reference.
  webhookBaseRef: getEnv(`REACT_APP_CODEBUILD_WEBHOOK_BASE_REF`),
  // The head reference name of the webhook event that triggers the current build.
  // It can be a branch reference or a tag reference
  webhookHeadRef: getEnv(`REACT_APP_CODEBUILD_WEBHOOK_HEAD_REF`),
  // Shows the webhook event that triggered the build
  //  pr/{pull-request-number}
  //   branch/{branch-name}
  //    tag/{tag-name}
  webhookTrigger: getEnv(`REACT_APP_CODEBUILD_WEBHOOK_TRIGGER`),
};

// dev when dev build
const buildVersionEnv = `${getEnv(`REACT_APP_ENV`)}`;

// build branch if we have one
let buildVersionBranch = ``;
if (codebuildEnv.isCodebuild && codebuildEnv.webhookBaseRef !== `master`){
  // is codebuild and not on master branch
  buildVersionBranch = ` ${codebuildEnv.webhookBaseRef ?? `-`}`;
}

// build date if we have one
let buildVersionDate = ``;
if (!codebuildEnv.isCodebuild) {
  buildVersionDate = `${(new Date()).toLocaleDateString()}`;
} else if (codebuildEnv.startTime !== undefined) {
  // built with codebuild and have start time
  const codeBuildDate = new Date(parseInt(codebuildEnv.startTime, 10));
  buildVersionDate = `${codeBuildDate.toLocaleDateString()}`;
}

// build number if we have one
let buildVersionBuildNumber;
if (codebuildEnv.isCodebuild) {
  // built with codebuild
  buildVersionBuildNumber = `${codebuildEnv.buildNumber ?? `?`}`;
} else {
  // built local
  buildVersionBuildNumber = `-local-`;
}

/**
 * App release version short from build environment
 */
export const appReleaseVersion = `${buildVersionDate} v${buildVersionBuildNumber}`;

/**
 * App version full from build environment
 */
export const appEnvVersion = `Version ${appReleaseVersion} ${buildVersionBranch} ${buildVersionEnv}`;

/**
 * App was built with as deployable build (usually for app.playgroundsessions.com or dev-app.playgroundsessions.com)
 */
export const isAppEnvProduction = getEnv(`NODE_ENV`) === 'production';
/**
 * if app was built for dev env (includes local dev and dev-app.playgroundsessions.com)
 */
export const isAppEnvDev = getEnv(`REACT_APP_ENV`) === 'dev';
/**
 * if app was built for local dev env
 *
 */
export const isAppEnvLocalDev = isAppEnvDev && !isAppEnvProduction;

